module.exports = __webpack_public_path__ + "img/attachment.a95e8875.svg";